export const suitability = {

	questions : [],
	suitabilityOK : false,
	questionsOK : []

}
